export class MasterData {
	showSchools: boolean = false;

	public async loadSchools() {
		this.showSchools = true;
	}
}